export const progressPercentageForDocuments = {};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateProgressPercentageForDocument = (progressEvent: any, temporaryDocumentId: string) => {
  const uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
  // @ts-expect-error -- This code was written prior to enforcing lint rules
  progressPercentageForDocuments[temporaryDocumentId] = {
    uploadPercentage,
  };
};
